import { Component, OnInit, ViewChild } from '@angular/core';
import { NgModel } from '@angular/forms';
import { ThemePalette } from '@angular/material/core';
import { ProgressSpinnerMode } from '@angular/material/progress-spinner';
import { take } from 'rxjs/operators';
import * as Constants from 'src/app/models/Constants';
import { ClearIdentityService } from 'src/app/services/clear-identity.service';
import { RootScopeService } from 'src/app/services/root-scope.service';


@Component({
  selector: 'app-clear-verification',
  templateUrl: './clear-verification.component.html',
  styleUrls: ['./clear-verification.component.scss']
})
export class ClearVerificationComponent implements OnInit {
  private readonly defaultCountryCode = 'US';
  private readonly defaultCountryCallingCode = '+1';
  @ViewChild('email') emailModel!: NgModel;
  errorMessage: string = '';
  deliveryMethod: string | undefined;
  activeTab: any;
  customMobileOption = { phoneNumber: '', name: 'mobileNumber', type: 'custom' };
  customEmailOption = { emailAdress: '', name: 'email', type: 'custom' };
  MobileNumber: string = '';
  Email: string = '';
  accountAccessOptions = Constants.Acccount_ACCESS_OPTIONS;
  clearEligibility = Constants.CLEAR_ELIGIBILITY;
  selections: string[] = Constants.CLEAT_OPTIONS;

  CL_constant = Constants.CLEAR_VERIFICATION_CONSTANTS;
  authenticationCompnent: any;
  color: ThemePalette = 'primary';
  mode: ProgressSpinnerMode = 'indeterminate';
  value = 0;
  patterns = Constants.PATTERNS;
  fraudAffidavit: string = "true";
  affidavitTypeConstants = Constants.CLEAR_OPTIONS_CODES;
  loaderType = Constants.LOADER_TYPE.CARD;

  constructor(public clearService: ClearIdentityService, public rootScope: RootScopeService) {
    const getFPTSupportData = this.rootScope.clientPropDataMap?.get(this.rootScope.activeCustTab.clientId)?.find(data => data.propertyName == Constants.CLEAR_VERIFICATION_CONSTANTS.IDENTITY_VERIFICATION_TYPES)?.propertyValue;
    this.fraudAffidavit = getFPTSupportData ? JSON?.parse(getFPTSupportData)?.FPT : null;
  }

  ngOnInit(): void {
    if (this.rootScope.activeCustTab.clearIdentityData.step1CheckList?.length == 0) {
      Constants.CLEAR_ELIGIBILITY.forEach(item => this.rootScope.activeCustTab.clearIdentityData.step1CheckList.push({ labelText: item, initialValue: item, value: item, checked: false, uuid: item + Math.random() }));
    }
    this.activeTab = this.rootScope.activeCustTab;
    this.clearService.getDeliveryOptions();
    this.setFraudDefaultSelectionWhenNoMobileNumbers();

  }

  public setFraudDefaultSelectionWhenNoMobileNumbers() {
    const fraudData = this.rootScope.activeCustTab?.clearFraudIdentityData;
    if (!fraudData) {
      return;
    }

    this.customMobileOption.phoneNumber = fraudData.mobileNumber || '';
    const hasMobileNumbers = Array.isArray(fraudData.mobileNumbers) && fraudData.mobileNumbers.length > 0;

    if (!hasMobileNumbers) {
      fraudData.defaultSelectedValue = this.customMobileOption;
      fraudData.isMobileSelected = false;
      fraudData.isEmailSelected = false;
    }
  }

  /**
   * Handles the logic for progressing through the identity verification steps.
   * @author VamsiKrishna CCR3-13396
   * - If the first step (`step1Active`) is not active, it activates it.
   * - If the first step is already active but the second part (`step1Part2`) is not, it activates the second part.
   * 
   * Updates the corresponding properties on `rootScope.activeCustTab.clearIdentityData`.
   */
  onClickStartADIV() {
    if (!this.activeTab.clearIdentityData.step1Active)
      this.rootScope.activeCustTab.clearIdentityData.step1Active = true;
    else if (this.activeTab.clearIdentityData.step1Active && !this.activeTab.clearIdentityData.step1Part2) {
      this.rootScope.activeCustTab.clearIdentityData.step1Part2 = true;
    }
    else if (!this.activeTab.clearFraudIdentityData.step1Active && this.rootScope.activeCustTab.clearFraudIdentityData.step1RadioSelection == "Yes") {
      this.rootScope.activeCustTab.clearFraudIdentityData.step1Active = true;
    }
  }

  /**
   * Determines whether the "Start AD IV" action should be enabled.
   *@author VamsiKrishna CCR3-13396
   * @returns {boolean} Returns `true` if `step1Part2` in `activeTab.clearIdentityData` is falsy, otherwise returns `false`.
   */
  enableStartADIV() {
    if (!this.activeTab.clearIdentityData.step1Active) {
      return true;
    }
    else if (!this.activeTab.clearIdentityData.step1Part2) {
      return true;
    }

    else return false;
  }

  /**
   * Determines whether the cancel action should be enabled based on the current state of the active tab's identity data.
   * @author VamsiKrishna CCR3-13396
   * @returns {boolean} Returns `true` if step 1 is active and step 2 part 2 is not active, otherwise returns `false`.
   */
  enableCancel() {
    if (!this.activeTab.clearIdentityData.step1Active || this.activeTab.clearIdentityData.step3Active||this.activeTab.clearIdentityData.step2Failed) {
      return false;
    }
    else if (!this.activeTab.clearIdentityData.step2Part2) {
      return true;
    } else return false;
  }

  /**
   * Determines whether the "Continue" action should be enabled based on the current state.
   *@author VamsiKrishna CCR3-13396
   * @returns {boolean} Returns `true` if `step1Part2` of `clearIdentityData` in the active tab is truthy, otherwise returns `false`.
   */
  enableContinue() {


    if (!this.activeTab.clearIdentityData.step1Part2 ||
      this.activeTab.clearIdentityData.step2Active) {
      return false;
    }
    else return true;
  }

  /**
   * Determines whether the "StartADIV" action should be disabled based on the current state of the active tab.
   *@author VamsiKrishna CCR3-13396
   * @returns {boolean} Returns `false` if `step1Active` is not active, or if both `step1Active` and `StartADIV` are true.
   *                    Returns `true` if `step1Active` is true and `StartADIV` is falsy.
   */
  disableStartADIV() {

    if (!this.activeTab.clearIdentityData.step1Active) {
      return false;
    }
    else if (this.activeTab.clearIdentityData.step1Active && this.activeTab.clearIdentityData?.startADIV)
      return false;
    else return true;
  }

  disableContinue() {
    if (!this.activeTab.clearIdentityData.step1Part3ToggleSelection &&
      this.activeTab.clearIdentityData.step1Part3 && !this.activeTab.clearIdentityData.step2Active) {
      return true;
    }
    else if (this.activeTab.clearIdentityData.step2Active &&
      !(this.activeTab.clearIdentityData.email.length > 0 || this.activeTab.clearIdentityData.mobileNumber.length > 0)) {
      return true;
    }
    else return false;
  }

  onClickCancelAidvProcess() {
    this.clearService.cancelAidvProcessDialog();
    this.rootScope.aidvDialogAction$.pipe(take(1)).subscribe((result: string) => {
      if (result === 'Yes') {
      
        const isAccountAccess =
        this.rootScope.activeCustTab.clearIdentityData.identityVerificationType === Constants.CLEAR_OPTIONS_CODES.ACCOUNT_ACCESS;
        const verificationId = isAccountAccess ? this.rootScope.activeCustTab.clearIdentityData.verificationId : this.rootScope.activeCustTab.clearFraudIdentityData.verificationId;
        this.clearService.invalidateIdentityVerificationSession(verificationId);

        // this.onClickCancel();
        this.clearService.resetClearIdentityData(isAccountAccess);
        this.rootScope.activeCustTab.clearIdentityData.isClearIdentityEnabled = true;
          isAccountAccess?this.rootScope.activeCustTab.clearIdentityData.completedAllSteps = false : this.rootScope.activeCustTab.clearFraudIdentityData.completedAllSteps = false;
        Constants.CLEAR_ELIGIBILITY.forEach(item => this.rootScope.activeCustTab.clearIdentityData.step1CheckList.push({ labelText: item, initialValue: item, value: item, checked: false, uuid: item + Math.random() }));
        this.rootScope.activeCustTab.authenticationEgainContent.authenticationType = '';
      }
    });
  }
  onClickCancel() {
    let clearIdentityData = this.rootScope.activeCustTab.clearIdentityData;
    switch (true) {
    
      case clearIdentityData.step1Active:

        clearIdentityData.step1CheckList = clearIdentityData.step1CheckList.map((item: any) => ({ ...item, checked: false }));
        clearIdentityData.startADIV = false;
        clearIdentityData.step1Part2 = false;
        clearIdentityData.step1Part3 = false;
        clearIdentityData.step2Active = false;
        clearIdentityData.step2Part2 = false;
        clearIdentityData.step1Complete = false;
        clearIdentityData.step1RadioSelection = "Yes";
        clearIdentityData.step1Part3ToggleSelection = false;
        clearIdentityData.step3Active = false;
        clearIdentityData.email = '';
        clearIdentityData.mobileNumber = '';
        clearIdentityData.countryCode = 'US';
        clearIdentityData.countryCallingCode='+1';
        clearIdentityData.step3Complete = false;
        clearIdentityData.step3Active = false;
        clearIdentityData.step3Failed = false;
        clearIdentityData.step3InfoMsg = '';
        clearIdentityData.step2Failed = false;
        clearIdentityData.step2Complete = false;
        this.activeTab.authenticationEgainContent.authenticationType = "";
        clearIdentityData.step1Active = false;
        clearIdentityData.timer = 0;
        clearIdentityData.exceededTimeLimit = false;
        break;
    }
  }

  onClickContinue() {
    let clearIdentityData = this.rootScope.activeCustTab.clearIdentityData;

    switch (true) {
      case clearIdentityData.step2Active && (clearIdentityData.email.length > 0 || clearIdentityData.mobileNumber.length > 0):
        this.clearService.sendClearIdentityVerification();
        break;
      case clearIdentityData.step1Part3 || (clearIdentityData.step1Part2 && clearIdentityData.step1RadioSelection == "Yes"):
        clearIdentityData.step2Active = true;
        clearIdentityData.step1Complete = true;
        break;
      case clearIdentityData.step1Part2 && clearIdentityData.step1RadioSelection == "No":
        clearIdentityData.step1Part3 = true;
        break;
    }
  }

  onToggleChange(event) {
    const activeTab = this.rootScope.activeCustTab;
    activeTab.clearIdentityData.step1Part3ToggleSelection = event.detail?.isOn;

    if (activeTab.clearIdentityData.step1Part3ToggleSelection) {
      activeTab.clearIdentityData.step2Active = true;
      activeTab.clearIdentityData.step1Complete = true;
    }
    else {
      activeTab.clearIdentityData.step2Active = false;
      activeTab.clearIdentityData.step1Complete = false;
      activeTab.clearIdentityData.countryCode = "US";
      activeTab.clearIdentityData.countryCallingCode = "+1";
      activeTab.clearIdentityData.mobileNumber = '';
      activeTab.clearIdentityData.email = '';
    }

  }


  /**
   * Handles the telephone input change event, updating the active tab's identity data
   * with the provided mobile number details and performing validation.
   *
   * @param {CustomEvent} event - The custom event triggered by the telephone input component.
   * @param {Object} event.detail - The detail object containing the telephone input data.
   * @param {string} event.detail.nationalNumber - The national number portion of the phone number.
   * @param {string} event.detail.country - The selected country code (e.g., 'US', 'GB').
   * @param {string} event.detail.countryCallingCode - The calling code for the selected country (e.g., '+1', '+44').
   * @param {boolean} event.detail.isValid - Indicates whether the entered phone number is valid.
   * @param {HTMLElement} event.srcElement - The source element of the event, used to display error messages.
   *CCR3-13372 - VamsiKrishna
   * @returns {void}
   *
   * @example
   * <app-tel-input (telInputChange)="onTelInputChange($event)"></app-tel-input>
   */
  onTelInputChange(event) {

    const activeTab = this.rootScope.activeCustTab;
    const isAccountAccess = activeTab.clearIdentityData.identityVerificationType === Constants.CLEAR_OPTIONS_CODES.ACCOUNT_ACCESS;
    const targetData = isAccountAccess ? activeTab.clearIdentityData : activeTab.clearFraudIdentityData;

    targetData.mobileNumber = event.detail.nationalNumber;
    targetData.countryCode = event.detail.country;
    targetData.countryCallingCode = event.detail.countryCallingCode;
   
    // if (!isAccountAccess) {
    //   const fraudData = this.rootScope.activeCustTab.clearFraudIdentityData;
    //   this.customMobileOption.phoneNumber = fraudData.MobileNumber || '';
    //   const hasMobileNumbers = Array.isArray(fraudData.mobileNumbers) && fraudData.mobileNumbers.length > 0;
    //   if (!hasMobileNumbers) {
    //     fraudData.defaultSelectedValue = this.customMobileOption;
    //   }
    // }

    if (!event.detail.isValid && event.detail.nationalNumber) {
      event.srcElement.errorMessage = "Invalid Mobile number.";
      this.errorMessage = "Invalid Mobile number.";
      this.rootScope.activeCustTab.clearFraudIdentityData.customMobileNumber = '';
    }
    else {
      this.rootScope.activeCustTab.clearFraudIdentityData.customMobileNumber = event.detail.nationalNumber;
      event.srcElement.errorMessage = "";
      this.errorMessage = "";
    }
  }



  /**
   *  @author Amarjeet - CCR3-14182
   * onRadioChange(value) - Updating radio button selection for fraud prevention and account access options in clear identity verification process.
   */
  onRadioChange(value: string) {
    this.rootScope.activeCustTab.clearIdentityData.identityVerificationType = value;
     console.log("Selected value:", value);
  }

  /**
   *  @author Amarjeet- CCR3-14182
   * onWebFreezeCheckChange(event) - Updating web freeze check selection for fraud prevention in clear identity verification process.
   */
  onWebFreezeCheckChange(event: any) {
    this.rootScope.activeCustTab.clearFraudIdentityData.isWebFreezeChecked = event.checked;
    console.log("Web Freeze Checked:", this.rootScope.activeCustTab.clearFraudIdentityData.isWebFreezeChecked);
  }

  /**
   *  @author Amarjeet- CCR3-14182
   * fraudStartADIVbuttonDisabled() - Determines if the Start AIDV button should be disabled based on fraud affidavit and user support group.
   */
  fraudStartADIVbuttonDisabled() {
    if (this.fraudAffidavit == 'true' && this.rootScope.userData.supportGroupList.includes('CN=NAAG-Alight-CarePortal-ConsentClientFraudProtection') && this.rootScope.activeCustTab.clearIdentityData.identityVerificationType === Constants.CLEAR_OPTIONS_CODES.FRAUD_PREVENTION) {
      return false;
    }
    else if ((this.fraudAffidavit == 'false' || this.fraudAffidavit == null) && this.rootScope.userData.supportGroupList.includes('CN=NAAG-Alight-CarePortal-ConsentClientFraudProtection') && this.rootScope.activeCustTab.clearIdentityData.identityVerificationType === Constants.CLEAR_OPTIONS_CODES.FRAUD_PREVENTION) {
      return false;
    }
    else if ((this.fraudAffidavit == 'false' || this.fraudAffidavit == null) && !this.rootScope.userData.supportGroupList.includes('CN=NAAG-Alight-CarePortal-ConsentClientFraudProtection') && this.rootScope.activeCustTab.clearIdentityData.identityVerificationType === Constants.CLEAR_OPTIONS_CODES.FRAUD_PREVENTION && this.rootScope.activeCustTab.clearFraudIdentityData.isWebFreezeChecked) {
      return false;
    }
    else if(this.rootScope.activeCustTab.clearIdentityData.identityVerificationType === Constants.CLEAR_OPTIONS_CODES.ENHANCED_IDENTITY){
      return false;
    }
    else return true;
  }

  /**
   *  @author Amarjeet- CCR3-14182
   * isWebFreezeCheckVisible() - Determines if the web freeze check should be visible based on fraud affidavit and user support group.
   */
  isWebFreezeCheckVisible() {

    if (this.fraudAffidavit == 'true' && !this.rootScope.userData.supportGroupList.includes('CN=NAAG-Alight-CarePortal-ConsentClientFraudProtection')) {
      this.rootScope.activeCustTab.clearFraudIdentityData.fraudProtectionMsg = true;
    }
    if ((this.fraudAffidavit == 'false' || this.fraudAffidavit == null) && !this.rootScope.userData.supportGroupList.includes('CN=NAAG-Alight-CarePortal-ConsentClientFraudProtection') && this.rootScope.activeCustTab.clearIdentityData.identityVerificationType === this.affidavitTypeConstants.FRAUD_PREVENTION) {
      return true;
    }
    else return false;
  }

  /**
   *  @author Amarjeet- CCR3-14182
   * fraudStartADIVbutton() - Activates the first step of the fraud affidavit process.
   */
  fraudStartADIVbutton() {
    const activeTab = this.rootScope.activeCustTab;

    if (this.rootScope.activeCustTab.clearIdentityData.identityVerificationType === Constants.CLEAR_OPTIONS_CODES.FRAUD_PREVENTION && activeTab.CS_SECURITY_LEVEL == Constants.securityLevels.SL4) {
      this.clearService.downgradeSLForFraudAccount();
    }
    activeTab.clearFraudIdentityData.step1Active = true;
  }

  /**
   *  @author Amarjeet- CCR3-14182
   * fraudCancelBtn() - Cancels the fraud affidavit process and resets all related data.
   */
  fraudCancelBtn() {
    const clearFraudIdentityData = this.rootScope.activeCustTab.clearFraudIdentityData;
    clearFraudIdentityData.step1Active = false;
    clearFraudIdentityData.step1Complete = false;
    clearFraudIdentityData.step2Active = false;
    clearFraudIdentityData.step2ToggleSelection = true;
    clearFraudIdentityData.step1RadioSelection = "Yes";
    clearFraudIdentityData.isWebFreezeChecked = false;
    clearFraudIdentityData.fraudProtectionMsg = false;
    this.rootScope.activeCustTab.clearIdentityData.identityVerificationType = Constants.CLEAR_OPTIONS_CODES.ACCOUNT_ACCESS;
    this.activeTab.authenticationEgainContent.authenticationType = "";
    clearFraudIdentityData.countryCode = 'US';
    clearFraudIdentityData.email = '';
    clearFraudIdentityData.mobileNumber = '';
    clearFraudIdentityData.customEmail = '';
    clearFraudIdentityData.customMobileNumber = '';
    clearFraudIdentityData.isEmailSelected = false;
    clearFraudIdentityData.isMobileSelected = false;
    clearFraudIdentityData.isCustomEmailSelected = false;
    clearFraudIdentityData.isCustomMobileSelected = false;    
    clearFraudIdentityData.defaultSelectedValue = '';
  }

  /**
   *  @author Amarjeet- CCR3-14182
   * fraudContinueBtn() - Continues the fraud affidavit process based on user selections.
   */
  fraudContinueBtn() {

    switch (true) {
      case this.rootScope.activeCustTab.clearFraudIdentityData.step2Active && this.rootScope.activeCustTab.clearFraudIdentityData.step1Complete:

        this.clearService.sendClearIdentityVerification();
        break;
      case this.rootScope.activeCustTab.clearFraudIdentityData.step1Active && this.rootScope.activeCustTab.clearFraudIdentityData.step1RadioSelection == "Yes":
        this.rootScope.activeCustTab.clearFraudIdentityData.step2Active = true;
        this.rootScope.activeCustTab.clearFraudIdentityData.step1Complete = true;
        this.rootScope.activeCustTab.clearFraudIdentityData.step2ToggleSelection = true;
        //this.setFraudDefaultSelectionWhenNoMobileNumbers();
        break;
      case this.rootScope.activeCustTab.clearFraudIdentityData.step1Active && this.rootScope.activeCustTab.clearFraudIdentityData.step1RadioSelection == "No":
        this.rootScope.activeCustTab.clearFraudIdentityData.step2Active = true;
        this.rootScope.activeCustTab.clearFraudIdentityData.step1Complete = true;
        this.rootScope.activeCustTab.clearFraudIdentityData.step2ToggleSelection = false;
        //this.setFraudDefaultSelectionWhenNoMobileNumbers();
        break;

    }
  }

  /**
   *  @author Amarjeet- CCR3-14182
   * fraudStep1RadioSelection() - Sets the radio selection for step 1 of the fraud affidavit process.
   */
  fraudStep1RadioSelection(value: string) {
    this.rootScope.activeCustTab.clearFraudIdentityData.step1RadioSelection = value;
  }


  fraudStep2RadioSelection(value: any) {

    if (value && value?.phoneNumber) {
      this.rootScope.activeCustTab.clearFraudIdentityData.email = '';
      this.rootScope.activeCustTab.clearFraudIdentityData.customEmail = '';

      if (!value.type) {
        this.rootScope.activeCustTab.clearFraudIdentityData.mobileNumber = value.phoneNumber;
        this.rootScope.activeCustTab.clearFraudIdentityData.countryCode = value.countryCode;
        this.rootScope.activeCustTab.clearFraudIdentityData.isMobileSelected = true;       
        this.rootScope.activeCustTab.clearFraudIdentityData.isCustomMobileSelected = false;
       
      }
      else {
        this.rootScope.activeCustTab.clearFraudIdentityData.customMobileNumber = value.phoneNumber;
        this.rootScope.activeCustTab.clearFraudIdentityData.mobileNumber = '';
        this.rootScope.activeCustTab.clearFraudIdentityData.countryCode = this.defaultCountryCode;
        this.rootScope.activeCustTab.clearFraudIdentityData.isMobileSelected = false;
        this.rootScope.activeCustTab.clearFraudIdentityData.isCustomMobileSelected = true;
      }
      this.rootScope.activeCustTab.clearFraudIdentityData.isEmailSelected = false;
      this.rootScope.activeCustTab.clearFraudIdentityData.isCustomEmailSelected = false;
    
    }
    else if (value && value?.emailAdress || value?.name === 'email') {
      this.rootScope.activeCustTab.clearFraudIdentityData.mobileNumber = '';

      if (!value?.type) {
        this.rootScope.activeCustTab.clearFraudIdentityData.isEmailSelected = true;
        this.rootScope.activeCustTab.clearFraudIdentityData.customEmail = '';
        this.rootScope.activeCustTab.clearFraudIdentityData.email = value.emailAdress;
        this.rootScope.activeCustTab.clearFraudIdentityData.isEmailSelected = true;        
        this.rootScope.activeCustTab.clearFraudIdentityData.isCustomEmailSelected = false;
      }
      else {
        
        this.rootScope.activeCustTab.clearFraudIdentityData.customEmail = this.rootScope.activeCustTab.clearFraudIdentityData.customEmail;
        this.rootScope.activeCustTab.clearFraudIdentityData.isEmailSelected = false;         
        this.rootScope.activeCustTab.clearFraudIdentityData.isCustomEmailSelected = true;
        this.rootScope.activeCustTab.clearFraudIdentityData.email = '';  
        
      }
      this.rootScope.activeCustTab.clearFraudIdentityData.isMobileSelected = false;
      this.rootScope.activeCustTab.clearFraudIdentityData.isCustomMobileSelected = false;
      this.rootScope.activeCustTab.clearFraudIdentityData.mobileNumber = '';      

    }
    else {
      this.rootScope.activeCustTab.clearFraudIdentityData.mobileNumber = '';
      this.rootScope.activeCustTab.clearFraudIdentityData.email = '';
      this.rootScope.activeCustTab.clearFraudIdentityData.countryCode = this.defaultCountryCode;
      this.rootScope.activeCustTab.clearFraudIdentityData.isEmailSelected = false;
      this.rootScope.activeCustTab.clearFraudIdentityData.isMobileSelected = false;
      this.rootScope.activeCustTab.clearFraudIdentityData.isCustomMobileSelected = false;
    
    }

  }

  onCustomEmailFocus() {
    const fraudData = this.rootScope.activeCustTab.clearFraudIdentityData;
    this.customEmailOption.emailAdress = fraudData.customEmail || '';
    fraudData.defaultSelectedValue = this.customEmailOption;
   // this.fraudStep2RadioSelection(this.customEmailOption);
  }

  onCustomMobileFocus() {
    const fraudData = this.rootScope.activeCustTab.clearFraudIdentityData;
    fraudData.isCustomMobileSelected = true;
    fraudData.isEmailSelected = false;
    fraudData.isMobileSelected = false;
    fraudData.isCustomEmailSelected = false;
    fraudData.defaultSelectedValue = this.customMobileOption;  
    fraudData.mobileNumber = ''; 
    fraudData.email = '';
    fraudData.customEmail = '';
  }

  /**
   *  @author Amarjeet- CCR3-14182
   * onFraudToggleChange() - Toggles the selection for step 2 of the fraud affidavit process.
   */
  onFraudToggleChange() {
    this.rootScope.activeCustTab.clearFraudIdentityData.step2ToggleSelection = !this.rootScope.activeCustTab.clearFraudIdentityData?.step2ToggleSelection;
  }

  /**
   *  @author Amarjeet- CCR3-14182
   * disableFraudContinueBtn() - Determines if the continue button for the fraud affidavit process should be disabled.
   */
  disableFraudContinueBtn() {
    if (this.rootScope.activeCustTab.clearFraudIdentityData.step2ToggleSelection) {
      return false;
    }
    else if (this.activeTab.clearFraudIdentityData.step2Active &&
      !(this.activeTab.clearFraudIdentityData.email.length > 0 || this.activeTab.clearFraudIdentityData.mobileNumber.length > 0)) {
      return true;
    }
    else return true;
  }


  onClickRefresh() {
    this.clearService.clickButton = true;
    this.clearService.getVerificationStatus(true);
  }

  /**
   * Determines whether the submit action should be disabled.
   *
   * The submit button is disabled only when step 2 of the clear identity flow is active
   * and neither an email nor a mobile number has been provided.
   *CCR3-13396 - VamsiKrishna
   * @returns `true` if submit must be disabled; otherwise, `false`.
   */
  disableSubmit() {
     if (this.clearService.isSubmitBtnClicked) {
      return true;
    }
    const activeTab = this.rootScope.activeCustTab;
    const isAccountAccess = activeTab.clearIdentityData.identityVerificationType === Constants.CLEAR_OPTIONS_CODES.ACCOUNT_ACCESS;
    const targetData = isAccountAccess ? activeTab.clearIdentityData : activeTab.clearFraudIdentityData;
    const { step2Active, email, mobileNumber } = targetData;

    if (!step2Active) {
      return false;
    }

    const hasEmail = isAccountAccess ? !!email?.trim() : (!!activeTab.clearFraudIdentityData.customEmail?.trim() || !!email?.trim());
    const hasMobile = isAccountAccess ? !!mobileNumber?.trim() : !!mobileNumber?.trim();

    const invalidEmail = hasEmail && !!this.emailModel?.invalid;
    const invalidMobile = hasMobile && !!this.errorMessage?.trim();

    return invalidEmail || invalidMobile || (!hasEmail && !hasMobile);
  }

  /**
   * Determines whether the submit action should be enabled for the current tab state.
   *CCR3-13396 - VamsiKrishna
   * @returns `true` when step 2 is active and step 3 is not active; otherwise, `false`.
   */
  enableSubmit() {
    const activeTab = this.rootScope.activeCustTab;
    const isAccountAccess = activeTab.clearIdentityData.identityVerificationType === Constants.CLEAR_OPTIONS_CODES.ACCOUNT_ACCESS;
    const targetData = isAccountAccess ? activeTab.clearIdentityData : activeTab.clearFraudIdentityData;

    if (targetData.step2Active && !targetData.step3Active && !targetData.step2Failed) {
      return true;
    }

    else return false;
  }



  onClicktryAgain(fraud?) {
    this.rootScope.activeCustTab[fraud ? 'clearFraudIdentityData' : 'clearIdentityData'].step2Failed = false;
    this.clearService.clearDeliveryOptionsData();
  }

  onClickRetry(fraud?) {
    if (this.activeTab[fraud ? 'clearFraudIdentityData' : 'clearIdentityData'].retryAttempts > 0) {
      this.activeTab[fraud ? 'clearFraudIdentityData' : 'clearIdentityData'].retryAttempts -= 1;
      this.activeTab[fraud ? 'clearFraudIdentityData' : 'clearIdentityData'].step3Failed = false;
      this.clearService.clearDeliveryOptionsData();
    }
    else {
      this.activeTab[fraud ? 'clearFraudIdentityData' : 'clearIdentityData'].step3Failed = true;
    }
  }

  /**
   * Code added for CCR3-14422 by Bharat Trikha
   */
  onClickResendLink() {
    const activeTab = this.rootScope.activeCustTab;
    const isAccountAccess = activeTab.clearIdentityData.identityVerificationType === Constants.CLEAR_OPTIONS_CODES.ACCOUNT_ACCESS;
    const verificationData = isAccountAccess ? activeTab.clearIdentityData : activeTab.clearFraudIdentityData;
    const fraudVerificationData = activeTab.clearFraudIdentityData;

    verificationData.step2Complete = false;
    verificationData.step3Active = false;
    verificationData.mobileNumber = '';
    verificationData.email = '';
    //copilot code suggestions :
    verificationData.step3InfoMsg = '';
    verificationData.step3ErrorMsg = '';
    verificationData.step3Complete = false;
    verificationData.step3Failed = false;
    verificationData.timer = 0;
    verificationData.exceededTimeLimit = false;

    if (!isAccountAccess) {
      fraudVerificationData.customEmail = '';
      fraudVerificationData.customMobileNumber = '';
      fraudVerificationData.isEmailSelected = false;
      fraudVerificationData.isMobileSelected = false;
      fraudVerificationData.isCustomEmailSelected = false;
      fraudVerificationData.isCustomMobileSelected = false;
      fraudVerificationData.countryCode = this.defaultCountryCode;
      fraudVerificationData.countryCallingCode = this.defaultCountryCallingCode;
      fraudVerificationData.defaultSelectedValue = '';
    }



    const verificationId = verificationData?.verificationId;


    this.clearService.invalidateIdentityVerificationSession(verificationId);

  }
  
   disableFraudSubmit() {
     if (this.clearService.isSubmitBtnClicked) {
      return true;
    }
    const activeTab = this.rootScope.activeCustTab;
    const isAccountAccess = activeTab.clearIdentityData.identityVerificationType === Constants.CLEAR_OPTIONS_CODES.ACCOUNT_ACCESS;
    const targetData = isAccountAccess ? activeTab.clearIdentityData : activeTab.clearFraudIdentityData;
    const { step2Active, email, mobileNumber } = targetData;

    if (!step2Active) {
      return false;
    }
    if(activeTab.clearFraudIdentityData.isEmailSelected || activeTab.clearFraudIdentityData.isMobileSelected){
     return false;
    }
    else if(activeTab.clearFraudIdentityData.customMobileNumber  && activeTab.clearFraudIdentityData.isCustomMobileSelected ){    
      return false;  
    }
    else{
    const hasEmail = isAccountAccess ? !!email?.trim() : (!!activeTab.clearFraudIdentityData.customEmail?.trim() || !!email?.trim());;
    const hasMobile = isAccountAccess ? !!mobileNumber?.trim() : !!mobileNumber?.trim();

    const invalidEmail = hasEmail && !!this.emailModel?.invalid;
    const invalidMobile = hasMobile && !!this.errorMessage?.trim();

    return invalidEmail || invalidMobile || (!hasEmail && !hasMobile) ;
    }
  }

  isClearSelectionDisabled(value: string) {
    const activeTab = this.rootScope.activeCustTab;
   if(value === Constants.CLEAR_OPTIONS_CODES.ACCOUNT_ACCESS  && (activeTab.CS_SECURITY_LEVEL==Constants.securityLevels.SL4 || activeTab?.clearIdentityData?.completedAllSteps || activeTab?.clearFraudIdentityData?.completedAllSteps)){ 
    // only auto-switch away from Account Access if it's the one currently selected, so it doesn't clobber an EIV/Fraud selection
    return true;
   }
   // Enhanced Identity Verification is only enabled once the call is fully secured
   if(value === Constants.CLEAR_OPTIONS_CODES.ENHANCED_IDENTITY && activeTab.CS_SECURITY_LEVEL != Constants.securityLevels.SL4){
    return true;
   }
   
   return false;
  }

  underAge(step3ErrorMsg) {
    if (step3ErrorMsg) {
      return step3ErrorMsg.find(item => {
        if (item?.fieldName) {
          return item?.fieldName?.includes(Constants.CLEAR_VERIFICATION_CONSTANTS.AGE_ERROR_CODE);
        }
        else {
          return item?.errorCode?.includes(Constants.CLEAR_VERIFICATION_CONSTANTS.AGE_ERROR_CODE);
        }
      })
    }
    else return false;
  }
  
}
